// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import {sync} from 'vuex-router-sync'
import App from './App'
import store from './vuex'
import router from './router'
import filters from './filter'
import dialog from './plugins/dialog'
import ajax from './plugins/ajax'
import validate from './plugins/validate'
Vue.use(dialog)
Vue.use(ajax)
Vue.use(validate)
// 判断是否是移动端用户
if (Vue.browser.isMobile) {
  window.location.href = 'http://m.91weijia.com'
}

Vue.config.productionTip = false
// 格式化金钱和数字的过滤器
for (let key in filters) {
  Vue.filter(key, filters[key])
}
// 将router放入到store中
sync(store, router)

const app = new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    this.$store.commit('changeCity')
    this.$store.commit('updateToken')
    this.$store.commit('updateCaptId')
    if (!(/register|login/.test(this.$route.path) && this.$route.query.backurl)) {
      // 不是登录或者注册页面并且没有backurl的
      this.$http({
        url: '/getVersion.jhtml',
        done (d) {
          app.$store.commit('compareVersion', d)
        }
      })
    }
    if (window.getDomList && window.placeHolder) {
      window.onload = function () {
        window.getDomList('input[placeholder]').forEach(function (element) {
          window.placeHolder(element, true)
        })
      }
    }
  }
})
window.app = app
// 当访问我的借款时候进行权限验证
router.beforeEach((to, from, next) => {
  if (to.matched.some(item => item.meta.requireAuth)) {
    app.$store.commit('updateToken')
    if (app.$store.state.token) {
      next()
    } else {
      // 如果没有登录，跳转到登录页面
      // app.$store.commit('changeLogin', {
      //   show: true,
      //   redirect: to.fullPath
      // })
      app.$router.push('/login')
    }
  } else {
    next()
  }
})
// 页面跳转之后让页面滚动到顶端
router.afterEach((route) => {
  if (window.getDomList && window.placeHolder) {
    setTimeout(() => {
      window.getDomList('input[placeholder]').forEach((element) => {
        window.placeHolder(element, true)
      })
    }, 20)
  }
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
})

app.$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js